var classList = require('dom-classlist');
var gsap = require('gsap');
var pubsub = require('pubsub');
var serialize = require('form-serialize');
var xhr = require('xhr');


module.exports = function () {

	var _form = document.querySelector('#vote-form')
	if(!_form) return;

	var _btSubmit = _form.querySelector('.bt')
	,	_inputs = _form.querySelectorAll('input[type="text"], input[type="password"], input[type="checkbox"], textarea')
	,	_confirmField = _form.querySelector('.confirm')
	,	isLoading = false
	,	to

	addHandlers()

	function addHandlers() {
		_btSubmit.addEventListener('click', clickSubmit)
	}

	function clickSubmit(e) {
		e.preventDefault();
		if(classList(_btSubmit).contains('ok')) return;
		submitForm();
	}



	function submitForm() {
		if(isLoading) return;
		isLoading = true;

		 
		 
		Array.prototype.forEach.call(_inputs, function(input){
			classList(input).remove('error')
		})

	    var currentUrl = document.location.href
	    ,   reqContent = serialize(_form) +'&';
	    ;
	   

		
	    //console.log(reqContent);
	    TweenMax.to(_btSubmit, .2, {autoAlpha:0, onComplete: function(){

	        xhr({
	                url: currentUrl
	            ,   headers:{"Content-Type": "application/x-www-form-urlencoded"}
	            ,   method:'POST'
	            ,   body: reqContent
	            }
	            ,   function (err, resp, body) {
	                    if(err == null){
	                    	isLoading = false;
	                        var JSONbody = JSON.parse(body);
	                        Array.prototype.forEach.call(JSONbody, function(el, i){
								if(el.level == 'error'){
		                        	classList(_form.querySelector('#'+el.field)).add('error')
		                        	console.log(el.field);
		                        	_confirmField.innerHTML = el.msg;
		                        	 
		                        } else {
                                    if(el.field == "msg")_confirmField.innerHTML = el.msg;
                                    if(el.field == 'refresh') location.reload(); 
			                        
		                        }

	                        });

	                        
	                        TweenMax.to(_btSubmit, .2, {autoAlpha: 1})
	                        


	                    } else {
	                        //_loaderMoreArticles.classList.remove('active')
	                        console.log(err);
	                    }
	                }
	        )
	    }})

	}
}
